import React from 'react';
import Button from '@mui/material/Button';
import Modal from '@/common/components/Modal/index';
import modalStyles from '@/common/containers/Modals/ConfirmModal/styles.less';
import { useTranslation } from 'react-i18next';

const ClosingCautionModal = ({ open, onClose }) => {
  const { t } = useTranslation();
  return (
    <Modal
      className={modalStyles.modal}
      overlayClassname={modalStyles.modalOverlay}
      open={open}
      onClose={onClose}
      overlay
    >
      <h4 className={modalStyles.modalTitle}>{t('Caution')}</h4>
      <p className={modalStyles.modalDescription}>
        {t(
          'Closing tasks module should not be started until all other modules are complete as Closing tasks are dependent on all previous modules being completed.'
        )}
      </p>
      <div className={modalStyles.modalBtns}>
        <Button variant="contained" color="primary" onClick={onClose}>
          {t('Ok')}
        </Button>
      </div>
    </Modal>
  );
};

export default ClosingCautionModal;
